exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kasa-report-table[data-v-39157dec]{width:100%;margin-top:4px}.kasa-report-table>*[data-v-39157dec]{width:100%}", ""]);

// exports
